/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VcdrOrgsInfoSummary { 
    /**
     * Staging vs Production
     */
    env: string;
    /**
     * Number of service instances associated with VCDR tenant orgs
     */
    num_vcdr_service_instances: number;
    /**
     * Number of orgs with VCDR shadow accounts assigned to it
     */
    num_vcdr_shadow_accounts: number;
    /**
     * Number of CSP orgs onboarded into VCDR service org
     */
    num_vcdr_tenant_orgs: number;
    /**
     * Org Type count
     */
    orgs_by_type: { [key: string]: number; };
}

